import CustomModal, { ModalBody, ModalFooter, ModalHeader } from '@/components/shared/CustomModal'
import { useWireValue } from '@forminator/react-wire'
import { useEffect, useState } from 'react'
import * as store from '@store'

const SelectRunsheetTabs = ({
    showModal,
    showHideModal,
    onAddToRunsheetClick,
}) => {
    const tabs = useWireValue(store.runsheetTabs)
    const [selectedTabs, setSelectedTabs] = useState([])
    
    // Filter out the main tab (ID 0) from the list of selectable tabs
    const additionalTabs = tabs.filter(tab => parseInt(tab.id, 10) !== 0)
    
    useEffect(() => {
        if (showModal) {
            setSelectedTabs([])
        }
    }, [showModal])
    
    const handleTabSelection = tabId => {
        setSelectedTabs(prev => 
            prev.includes(tabId) 
                ? prev.filter(id => id !== tabId)
                : [...prev, tabId],
        )
    }
    
    const handleSubmit = () => {
        // Always include the main tab (ID 0) and any additional selected tabs
        const allSelectedTabs = [0, ...selectedTabs]
        
        onAddToRunsheetClick(allSelectedTabs)
        showHideModal(false)
    }
    
    return (
        <CustomModal
            title="Select Runsheet Tabs"
            open={showModal}
            modalHandler={() => showHideModal(!showModal)}>
            <ModalHeader>
                Runsheet Tabs
                <div className="text-sm">
                    Select additional tabs to add the documents to (Main tab is always included)
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="mb-4">
                    <div className="font-medium">Main Tab</div>
                    <div className="text-sm text-gray-500">Documents will always be added to the main tab</div>
                </div>
                <div className="font-medium mb-2">Additional Tabs</div>
                {additionalTabs.map(tab => (
                    <div key={tab.id} className="flex items-center gap-2">
                        <input 
                            className="checkbox checkbox-sm" 
                            type="checkbox" 
                            checked={selectedTabs.includes(tab.id)} 
                            onChange={() => handleTabSelection(tab.id)}/>
                        {tab.name}
                    </div>
                ))}
            </ModalBody>
            <ModalFooter>
                <button 
                    className="btn btn-secondary" 
                    onClick={() => showHideModal(false)}>
                    Cancel
                </button>
                <button 
                    className="btn btn-primary" 
                    onClick={handleSubmit}>
                    Add to Selected Tabs
                </button>
            </ModalFooter>
        </CustomModal>
    )
}

export default SelectRunsheetTabs